import React, { useEffect, useRef, useState } from 'react';
import {
  differenceInSeconds,
  differenceInMinutes,
  differenceInHours,
  differenceInDays,
} from 'date-fns';
import { HoneyPot, FormNote } from '../../components/FormParts';
import { formValues, submitInquiry } from '../../lib/api/forms';
import SectionTitle from '../../components/SectionTitle';

import shapeImg1 from '../../assets/img/contact/shape-1-1.png';
import shapeImg2 from '../../assets/img/contact/shape-1-2.png';
import shapeImg3 from '../../assets/img/contact/shape-1-3.png';
import shapeImg4 from '../../assets/img/contact/shape-1-4.png';
import titleImg from '../../assets/img/category/title.svg';
import contactBG from '../../assets/img/contact/bg-5.jpg';

// Next intake date for the countdown, for example '2027-01-04T00:00:00'.
// While it is null the countdown is hidden (the client has not given a date yet).
const INTAKE_DATE = null;

const Contact = () => {
  const formRef = useRef();
  const targetDate = INTAKE_DATE ? new Date(INTAKE_DATE) : null;

  const calculateTimeLeft = () => {
    if (!targetDate) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    const now = new Date();
    const timeLeft = {
      days: differenceInDays(targetDate, now),
      hours: differenceInHours(targetDate, now) % 24,
      minutes: differenceInMinutes(targetDate, now) % 60,
      seconds: differenceInSeconds(targetDate, now) % 60,
    };

    return timeLeft;
  };
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    if (!targetDate) return undefined;
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  }, [timeLeft]);

  const TimerData = [
    { countdownTimeLeft: timeLeft.days, countdownTitle: 'DAYS' },
    { countdownTimeLeft: timeLeft.hours, countdownTitle: 'HOURS' },
    { countdownTimeLeft: timeLeft.minutes, countdownTitle: 'MINUTES' },
    { countdownTimeLeft: timeLeft.seconds, countdownTitle: 'SECONDS' },
  ];

  const [state, setState] = useState({ status: 'idle', message: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setState({ status: 'sending', message: '' });
    try {
      await submitInquiry({ ...formValues(formRef.current), source: 'home' });
      formRef.current.reset();
      setState({ status: 'success', message: 'Thank you. Your message has been sent. We will reply soon.' });
    } catch (err) {
      setState({ status: 'error', message: err.message });
    }
  };

  return (
    <div
      id="it-contact"
      className="it-contact-area it-contact-style-4 z-index p-relative pt-120 pb-100"
    >
      <div className="it-contact-shape-1 d-none d-lg-block">
        <img src={shapeImg1} alt="" />
      </div>
      <div className="it-contact-shape-2 d-none d-lg-block">
        <img src={shapeImg2} alt="" />
      </div>
      <div className="it-contact-shape-3 d-none d-xxl-block">
        <img src={shapeImg3} alt="" />
      </div>
      <div className="it-contact-shape-4 d-none d-lg-block">
        <img src={shapeImg4} alt="" />
      </div>
      <div className="container">
        <div className="row align-items-center">
          <div
            className="col-xl-7 col-lg-7 wow animate__fadeInLeft"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <div className="it-contact-left">
              <SectionTitle
                itemClass="it-contact-title-box pb-20"
                subTitleClass="it-section-subtitle-5"
                subTitle="Admissions"
                titleClass="it-section-title-3"
                title="Apply Now For Our Next Intake"
                titleImage={titleImg}
              />
              <div className="it-contact-text pb-15">
                <p>
                  Our Diploma and Higher Diploma in Insurance and Risk
                  Management start in January and June. Send us a message and
                  our team will get back to you with the next steps.
                </p>
              </div>
              {targetDate && (<div className="it-contact-timer-box mb-40">
                <div className="row">
                  {TimerData.map((timer, index) => (
                    <div
                      key={index}
                      className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6"
                    >
                      <div className="it-contact-timer text-center">
                        <h6>{timer.countdownTimeLeft}</h6>
                        <i>{timer.countdownTitle}</i>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)}
            </div>
          </div>
          <div
            className="col-xl-5 col-lg-5 wow animate__fadeInRight"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <div
              className="it-contact-wrap"
              style={{ backgroundImage: `url(${contactBG})` }}
            >
              <span className="it-section-subtitle-5 sky">
                <img src={titleImg} alt="" />
                Have A Question?
              </span>
              <h4 className="it-contact-title pb-15">
                Send Us A Message
              </h4>
              <form ref={formRef} onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-12 mb-15">
                    <div className="it-contact-input-box">
                      <input type="text" name="name" placeholder="Your Name" required maxLength={120} />
                    </div>
                  </div>
                  <div className="col-12 mb-15">
                    <div className="it-contact-input-box">
                      <input type="email" name="email" placeholder="Your Email" required maxLength={200} />
                    </div>
                  </div>
                  <div className="col-12 mb-15">
                    <div className="it-contact-input-box">
                      <input type="tel" name="phone" placeholder="Phone" maxLength={30} />
                    </div>
                  </div>
                  <div className="col-12 mb-30">
                    <div className="it-contact-textarea-box">
                      <textarea name="message" placeholder="Message" required maxLength={4000}></textarea>
                    </div>
                  </div>
                </div>
                <HoneyPot />
                <button type="submit" className="ed-btn-square" disabled={state.status === 'sending'}>
                  <span>{state.status === 'sending' ? 'Sending...' : 'Send Message'}</span>
                </button>
                <FormNote status={state.status}>{state.message}</FormNote>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Contact;
